module.exports = __webpack_public_path__ + "img/0x90df11a8cce420675e73922419e3f4f3fe13cccb.d5c1917d.png";